import { Chip, Stack, SxProps } from '@mui/material'
import { CircleFlag } from '@/components/CircleFlag'

type Region = {
  iso2: string
  name: string
  displayLabel?: string
}

type Props = {
  ChipSx?: SxProps
  testId?: string
  region: Region
  onDelete?: () => void
  withFlag?: boolean
}

export const RegionChip = ({ ChipSx, testId, region, withFlag, onDelete }: Props) => {
  return (
    <Chip
      size="small"
      key={`chips-${region.iso2}`}
      sx={ChipSx}
      data-testid={testId ?? `selected-region-chip-${region.iso2}`}
      label={
        <Stack
          direction="row"
          alignItems="center"
          gap={0.75}
          sx={{ ml: withFlag ? -0.85 : undefined, pr: withFlag ? 0.25 : undefined }}
        >
          {withFlag && (
            <CircleFlag countryCode={region.iso2.toLowerCase()} style={{ height: '1.25rem' }} />
          )}
          {region.displayLabel || region.name}
        </Stack>
      }
      onDelete={onDelete}
    />
  )
}
